module.exports = __webpack_public_path__ + "static/serv01-8bb4efeb01e9ff9a8cf87e9c3fd794b3.png";